import { AfterViewInit, Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
declare const YT: any;
@Component({
    selector: 'iq-media-video',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-media-video.component.html',
    styleUrl: './iq-media-video.component.scss',
})
export class IqMediaVideoComponent implements AfterViewInit {
    @Input()
    id: string;

    @Input({required: true})
    videoId: string;

    @ViewChildren('videoPlayer')
    videoPlayer: QueryList<ElementRef<HTMLDivElement>>;

    constructor() {}

    ngAfterViewInit(): void {
        if(typeof YT === 'undefined') return;

        const player = new YT.Player(this.videoPlayer.first.nativeElement, {
            width: '100%',
            playerVars: {
                playsinline: 1,
                listType: 'playlist',
                list: this.videoId,
            },
            host: 'http://www.youtube-nocookie.com',
        });
    }
}
